import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

const AccessKeyModal = ({ onClose }) => {
    const { loginWithKey } = useAuth();
    const { t } = useTranslation();
    const [key, setKey] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleInputChange = (e) => {
        let value = e.target.value;
        // NEU: Wir prüfen, ob ein Link eingefügt wurde und extrahieren den Key.
        try {
            if (value.includes('?key=')) {
                const url = new URL(value);
                value = url.searchParams.get('key') || '';
            }
        } catch (error) {
            // Ignoriere ungültige URLs
        }
        setKey(value.trim()); // Entferne Leerzeichen
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!key || loading) return;
        setError('');
        setLoading(true);
        try {
            await loginWithKey(key);
            // Bei Erfolg wird der AuthContext den Nutzer zur MapPage navigieren.
        } catch (err) {
            setError(err.message || 'Invalid or expired key.');
            setLoading(false);
        }
    };

    return (
        <div className="modal-backdrop" onClick={onClose}>
            <motion.div 
                className="modal-content" 
                onClick={e => e.stopPropagation()}
                initial={{ y: 200, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ type: "spring", stiffness: 100, damping: 20 }}
            >
                <h2 style={{ textAlign: 'center', marginTop: 0 }}>{t('enter_access_key_title', 'Enter Your Access Key')}</h2>
                <p style={{ textAlign: 'center', color: '#4a5568', fontSize: '0.9em', marginBottom: '20px' }}>
                    {t('access_key_hint', 'Enter your word combo (e.g. "apple-brain")')}
                </p>
                <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                    <input
                        type="text"
                        value={key}
                        onChange={handleInputChange}
                        placeholder="spoon-guitar"
                        style={{ 
                            fontSize: '1.2em', 
                            textAlign: 'center', 
                            fontFamily: 'monospace',
                            textTransform: 'lowercase',
                            letterSpacing: '0.05em',
                            padding: '14px'
                        }}
                        required
                        autoFocus
                    />
                    {error && <p style={{ color: 'var(--color-danger-glow)', textAlign: 'center', margin: 0, fontWeight: 'bold' }}>{error}</p>}
                    <button type="submit" disabled={loading} className="button-primary">
                        {loading ? t('loading') : t('restore_access_button')}
                    </button>
                </form>
            </motion.div>
        </div>
    );
};

export default AccessKeyModal;
